<template>
  <div id="policy-page" class="terms-content">
    <article-generator :title="POLICY.title" :content="POLICY.content" />
  </div>
</template>

<script setup lang="ts">
import articleGenerator from '@/components/common/article-generator.vue'

import { ArticleContentStructureType } from '@/types/article-generator'

const { t } = useI18n()

definePageMeta({
  layout: 'terms',
  middleware: ['check-region'],
})

const POLICY = computed(() => ({
  title: t('footer_service_agreement'),
  content: [
    {
      type: ArticleContentStructureType.HTML,
      content: t('service_terms_content'),
    },
  ],
}))
</script>

<style lang="scss" scoped></style>
